import { render, staticRenderFns } from "./ProjectClassScheduleEdit.vue?vue&type=template&id=0b53be54&scoped=true"
import script from "./ProjectClassScheduleEdit.vue?vue&type=script&lang=js"
export * from "./ProjectClassScheduleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b53be54",
  null
  
)

export default component.exports